import React from "react";
import Modal from "react-modal";
import Navbar_render from "../Pages/ProjectV2/Render/Nav_render/Navbar_render";

Modal.setAppElement("#root");

export default function EC_Render({
  isOpen,
  children,
  closeModal,
  title,
  styleTop,
  styleLeft,
  styleUnit,
}) {
  let styleModel = {
    content: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor:"#121212",
      height: "100%",
      width: "100%",
      maxWidth: "100%",
      maxHeight: "100%",
      borderRadius: "0rem",
      padding: 0,
      overflow: "auto",
      // zIndex: 9,
    },
    overlay:{backgroundColor:'rgba(214, 150, 150, 0.75)'}
  };
  if (styleTop) {
    styleModel.content.top = styleTop + (styleUnit || "%");
  }
  if (styleLeft) {
    styleModel.content.left = styleLeft + (styleUnit || "%");
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={styleModel}
      className="ecModal"
    >
      <div className="w-full h-full">
        {/* <div>
            <Navbar_render closeModal={closeModal}/>
        </div> */}
        {/* <div
          className="border-b-2 flex justify-between text-white p-2 pr-5"
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1,
            backgroundColor: "var(--gray)",
          }}
        >
          <span>{title}</span>
          <span onClick={closeModal} style={{ cursor: "pointer" }}>
            X
          </span>
        </div> */}
        <div className="w-full h-full">{children}</div>
      </div>
    </Modal>
  );
}
